import React from 'react';

import OutboundLink from '@components/OutboundLink/OutboundLink';

const ProductHuntBadge = () => {
  return (
    <OutboundLink
      eventName={`productHuntClick`}
      className="product-hunt-badge"
      href="https://www.producthunt.com/posts/casterkit?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-casterkit"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=198613&theme=light"
        alt="CasterKit - Curated list of resources for podcasters | Product Hunt Embed"
        width="250px"
        height="54px"
      />
    </OutboundLink>
  );
};

export default ProductHuntBadge;
